var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.loading && _vm.group
    ? _c(
        "div",
        { attrs: { id: "value-frames" } },
        [
          _c(
            "b-row",
            { staticClass: "mb-5" },
            [
              _c(
                "b-col",
                { attrs: { lg: "7" } },
                [
                  _c("h4", { staticClass: "mb-3" }, [
                    _vm._v("Choose your item's size:"),
                  ]),
                  _c("standard-size-selector", {
                    model: {
                      value: _vm.itemSize,
                      callback: function ($$v) {
                        _vm.itemSize = $$v
                      },
                      expression: "itemSize",
                    },
                  }),
                  _c("h4", { staticClass: "mb-3 mt-5" }, [
                    _vm._v("Choose your frame's style:"),
                  ]),
                  _c("moulding-options", {
                    attrs: { lengths: _vm.group.lengths },
                    model: {
                      value: _vm.length,
                      callback: function ($$v) {
                        _vm.length = $$v
                      },
                      expression: "length",
                    },
                  }),
                  _c("h4", { staticClass: "mb-3 mt-5" }, [
                    _vm._v("Choose your mount colour (optional):"),
                  ]),
                  _c("mountboard-colours", {
                    model: {
                      value: _vm.selectedBoard,
                      callback: function ($$v) {
                        _vm.selectedBoard = $$v
                      },
                      expression: "selectedBoard",
                    },
                  }),
                  _c("h4", { staticClass: "mb-3 mt-5" }, [
                    _vm._v("Choose your picture frame's design:"),
                  ]),
                  _c("frame-design-selector", {
                    attrs: {
                      "group-id": _vm.group.id,
                      "item-size": _vm.artworkSize,
                      "length-sku": _vm.length.sku,
                      mount: _vm.selectedBoard,
                    },
                    model: {
                      value: _vm.frameSize,
                      callback: function ($$v) {
                        _vm.frameSize = $$v
                      },
                      expression: "frameSize",
                    },
                  }),
                ],
                1
              ),
              _c("b-col", [
                _c(
                  "div",
                  { staticClass: "sticky-top pt-3" },
                  [
                    _c("frame-visualisation", {
                      attrs: {
                        sku: _vm.length.sku,
                        "artwork-dimensions": _vm.artworkSize,
                        "rebate-dimensions": _vm.rebateSize,
                        backing: true,
                        mount: _vm.mountOption,
                      },
                    }),
                    _c("p", { staticClass: "text-center" }, [
                      _vm._v(_vm._s(_vm.frameDescription)),
                    ]),
                    _c("p", { staticClass: "lead text-center" }, [
                      _vm._v("Price: "),
                      _c("strong", [_vm._v("£" + _vm._s(_vm.price))]),
                      _vm._v(" each (" + _vm._s(_vm.vatMode) + " VAT)"),
                    ]),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { lg: "7" } },
                [
                  _c("h4", { staticClass: "mb-3" }, [
                    _vm._v("Choose your glazing options:"),
                  ]),
                  _c("glazing-options", {
                    attrs: {
                      "frame-size": _vm.frameSize,
                      "group-id": _vm.groupId,
                    },
                    model: {
                      value: _vm.glazing,
                      callback: function ($$v) {
                        _vm.glazing = $$v
                      },
                      expression: "glazing",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { staticClass: "mb-3" },
                [
                  _c("h4", { staticClass: "mb-3" }, [
                    _vm._v("Choose you hangings/fixings:"),
                  ]),
                  _c("fixing-options", {
                    attrs: {
                      "rebate-size": _vm.rebateSize,
                      "group-id": _vm.groupId,
                    },
                    model: {
                      value: _vm.fixings,
                      callback: function ($$v) {
                        _vm.fixings = $$v
                      },
                      expression: "fixings",
                    },
                  }),
                  _c("h4", { staticClass: "mb-3 mt-5" }, [
                    _vm._v("Order Specification"),
                  ]),
                  _c("frame-specification", {
                    attrs: {
                      "item-size": _vm.itemSize,
                      "frame-size": _vm.frameSize,
                      length: _vm.length,
                      "has-mount": _vm.hasMount,
                      mount: _vm.selectedBoard,
                      glazing: _vm.glazing,
                      fixings: _vm.fixings,
                      "unit-price": _vm.discountedPrice,
                      validation: _vm.validation,
                    },
                  }),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Quantity:",
                        "label-cols-sm": "5",
                        "label-size": "lg",
                        "label-align-sm": "right",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          size: "lg",
                          type: "number",
                          number: "",
                          step: "1",
                          min: "1",
                        },
                        model: {
                          value: _vm.quantity,
                          callback: function ($$v) {
                            _vm.quantity = $$v
                          },
                          expression: "quantity",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-alert",
                    {
                      attrs: {
                        show:
                          (!_vm.stock.frame || !_vm.stock.mount) &&
                          !_vm.loadingStock,
                        variant: "danger",
                      },
                    },
                    [
                      !_vm.stock.frame
                        ? _c("p", { staticClass: "mb-0" }, [
                            _vm._v("There is not enough stock of the "),
                            _c("strong", [_vm._v("moulding")]),
                            _vm._v(" you have chosen to fulfil your order."),
                          ])
                        : _vm._e(),
                      !_vm.stock.mount
                        ? _c("p", { staticClass: "mb-0" }, [
                            _vm._v("There is not enough stock of the "),
                            _c("strong", [_vm._v("mountboard")]),
                            _vm._v(" you have chosen to fulfil your order."),
                          ])
                        : _vm._e(),
                    ]
                  ),
                  _c(
                    "b-alert",
                    {
                      attrs: { show: _vm.isCollectionOnly, variant: "warning" },
                    },
                    [
                      !_vm.deliveryValidation.frame.isValid
                        ? _c("p", { staticClass: "mb-0" }, [
                            _vm._v(
                              "Due to the size of the frame we are unable to delivery this item. However, you are welcome to collect from our workshop."
                            ),
                          ])
                        : !_vm.deliveryValidation.glazing.isValid
                        ? _c("p", { staticClass: "mb-0" }, [
                            _vm._v(
                              "Due to the size of the glass in the frame we are unable to delivery this item. However, you are welcome to collect from our workshop."
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "text-right" },
                    [
                      _c(
                        "b-overlay",
                        {
                          staticClass: "d-inline-block",
                          attrs: {
                            show: _vm.isBuyButtonLoading,
                            rounded: "",
                            "spinner-small": "",
                          },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                size: "lg",
                                variant: _vm.isBuyButtonValid
                                  ? "success"
                                  : "danger",
                                disabled: _vm.isBuyButtonDisabled,
                              },
                              on: { click: _vm.addToCart },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "material-icons mr-2" },
                                [_vm._v("shopping_cart")]
                              ),
                              _vm._v(
                                "Add to Cart (£" +
                                  _vm._s(_vm.totalPrice) +
                                  " " +
                                  _vm._s(_vm.vatMode) +
                                  " VAT)"
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm.discount > 0
                        ? _c("p", [
                            _c("em", [
                              _vm._v(
                                "(You save " + _vm._s(_vm.discount) + "%)"
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "b-card",
                    { staticClass: "my-3" },
                    [
                      _c("h4", { staticClass: "card-title" }, [
                        _vm._v("Volume Discounts"),
                      ]),
                      _c("p", { staticClass: "card-text" }, [
                        _vm._v("The more you buy, the more you save!"),
                      ]),
                      _c("discounts-breakdown", {
                        attrs: {
                          "sku-prefix": "UVF",
                          "item-type": "Frame",
                          price: _vm.exVatPrice,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }